import {map, reduce, sorted} from './array';
import {isArray, isFunction, isNumber} from './is';
import {keys} from './object';

// Adapted from https://github.com/substack/json-stable-stringify/
const
    stringify = (node, replacer, space) => {
        replacer = replacer || ((key, value) => value);
        space = (
            isNumber(space) ?
                (space > 0 ?
                    new Array(space + 1).join(' ') :
                    '') :
                (space || ''));
        return (
            (function stringify(parent, key, node, depth, seen) {
                const
                    cycle = () => {
                        if (seen.indexOf(node) !== -1) {
                            throw new TypeError('Converting circular structure to JSON');
                        } else {
                            return seen.concat([node]);
                        }
                    },
                    indent = (
                        space &&
                        `\n${new Array(depth + 1).join(space)}`);

                while (node && isFunction(node.toJSON)) {
                    node = node.toJSON(String(key));
                }
                node = replacer.call(parent, key, node);
                if (node === undefined) {
                    return;
                } else if (typeof node !== 'object' || node === null) {
                    return JSON.stringify(node);
                } else {
                    seen = cycle();
                    return (
                        isArray(node) ?
                            `[${
                                map(node,
                                    (child, i, node) => (
                                        `${indent}${space}${
                                            stringify(node, i, child, depth + 1, seen) ||
                                            JSON.stringify(null)
                                        }`))
                                .join(',')
                            }${indent}]` :
                            `{${
                                reduce(
                                    sorted(keys(node)),
                                    (out, key) => {
                                        const value = (
                                                stringify(node, key, node[key], depth + 1, seen));

                                        if (value) {
                                            out.push(
                                                `${indent}${space}${JSON.stringify(key)}${space ? ': ' : ':'}${value}`);
                                        }
                                        return out;
                                    },
                                    [])
                                .join(',')
                            }${indent}}`);

                }
            }({'': node}, '', node, 0, [])));
    };

export {
    stringify
};
